export abstract class BaseEvent<TData extends Record<string, unknown>> {
  abstract name: string;

  constructor(public callback: (data: TData) => void) {}
}
